
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download_app",
      function () {
        return require("private-next-pages/download_app.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/download_app"])
      });
    }
  